export const ARTWORK_URL = process.env.REACT_APP_ARTWORK_URL || 'https://artwork-cache.pod.nimey-local.de'